import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Box, Typography } from '@mui/material'

import { J2Validate, J2Caution } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { HardwareTestResultModel } from 'src/Libs/installation-details/models'
import { getHardwareTestMessage, getHardwareTestFinalScreenStatus } from '../../../../utils'
import ReactMarkdown from 'react-markdown'
import DOMPurify from 'dompurify'

interface FinalScreenProps {
  testResultData: HardwareTestResultModel
}

const useStyles = makeStyles()(theme => ({
  contentContainer: {
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(4)} 0`,
    minHeight: '235px',
    '@media (max-width: 650px)': {
      paddingInline: theme.spacing(2),
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper2,
    border: `1px solid ${theme.palette.background.paperBorder}`,
    borderRadius: theme.shape.borderRadius,
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
    width: '100%',
    maxWidth: '600px',
    '@media (max-width: 650px)': {
      textAlign: 'center',
    },
  },
  title: {
    margin: `${theme.spacing(2)} 0`,
  },
  icon: {
    width: '90px',
    height: '90px',
  },
  cardMessage: {
    '-webkit-box-orient': 'vertical',
    'line-clamp': '6',
    '-webkit-line-clamp': '6',
    overflow: 'hidden',
    display: '-webkit-box',
    wordBreak: 'break-all',
    width: '100%',
    textAlign: 'left',
    whiteSpace: 'pre-wrap',

    a: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
    },
  },
}))

export const HardwareTestResult: FC<FinalScreenProps> = ({ testResultData }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const isSuccessful = testResultData?.state === 'SUCCESS'
  const message = getHardwareTestMessage(testResultData?.message, t)

  return (
    <Box className={classes.contentContainer}>
      <Box display="flex" flexDirection="column" alignItems="center">
        {isSuccessful ? <J2Validate color="primary" className={classes.icon} /> : <J2Caution color="error" className={classes.icon} />}
        <Typography className={classes.title}>{getHardwareTestFinalScreenStatus(testResultData?.state, t)}</Typography>
      </Box>
      <Box className={classes.card}>
        <ReactMarkdown className={classes.cardMessage}>{DOMPurify.sanitize(message)}</ReactMarkdown>
      </Box>
    </Box>
  )
}
